import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_LT.json';
import audios from './LOVE_AUDIOS_LT.json';

export const LOVE_DATA_LT: ServiceData = {
  articles,
  audios,
};
